/* 
//product-slider
var swiper = new Swiper(".product_slider", {
      slidesPerView: 1,
      spaceBetween: 10,
     navigation: {
        nextEl: '.next-btn',
        prevEl: '.prev-btn',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
        breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
    });

var swiper = new Swiper(".before-after-slider", {
      slidesPerView: 1,
      spaceBetween: 30,
      allowTouchMove: false,
     navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
          breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 50,
        }
      },
    });

function initComparisons() {
  var x, i;
  // find all elements with an "overlay" class
  x = document.getElementsByClassName("img-comp-overlay");
  for (i = 0; i < x.length; i++) {
    //once for each "overlay" element:
    // pass the "overlay" element as a parameter when executing the compareImages function:
    compareImages(x[i]);
  }
  function compareImages(img) {
    var slider, img, clicked = 0, w, h;
    // get the width and height of the img element
    w = img.offsetWidth;
    h = img.offsetHeight;
    // set the width of the img element to 50%
    img.style.width = (w / 2) + "px";
    // create slider:
    slider = document.createElement("DIV");
    slider.setAttribute("class", "img-comp-slider");
    // insert slider
    img.parentElement.insertBefore(slider, img);
    // position the slider in the middle:
    slider.style.top = (h / 2) - (slider.offsetHeight / 2) + "px";
    slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";
    // execute a function when the mouse button is pressed:
    slider.addEventListener("mousedown", slideReady);
    // and another function when the mouse button is released:
    window.addEventListener("mouseup", slideFinish);
    // or touched (for touch screens:
    slider.addEventListener("touchstart", slideReady);
    // and released (for touch screens:
    window.addEventListener("touchend", slideFinish);
    function slideReady(e) {
      // prevent any other actions that may occur when moving over the image:
      e.preventDefault();
      // the slider is now clicked and ready to move:
      clicked = 1;
      // execute a function when the slider is moved:
      window.addEventListener("mousemove", slideMove);
      window.addEventListener("touchmove", slideMove);
    }
    function slideFinish() {
      // the slider is no longer clicked:
      clicked = 0;
    }
    function slideMove(e) {
      var pos;
      // if the slider is no longer clicked, exit this function:
      if (clicked == 0) return false;
      // get the cursor's x position:
      pos = getCursorPos(e)
      // prevent the slider from being positioned outside the image:
      if (pos < 0) pos = 0;
      if (pos > w) pos = w;
      // execute a function that will resize the overlay image according to the cursor:
      slide(pos);
    }
    function getCursorPos(e) {
      var a, x = 0;
      e = (e.changedTouches) ? e.changedTouches[0] : e;
      // get the x positions of the image:
      a = img.getBoundingClientRect();
      // calculate the cursor's x coordinate, relative to the image:
      x = e.pageX - a.left;
      // consider any page scrolling:
      x = x - window.pageXOffset;
      return x;
    }
    function slide(x) {
      // resize the image:
      img.style.width = x + "px";
      // position the slider:
      slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
    }
  }
}
window.addEventListener('load', function() {
initComparisons();
})

const discountCallout = document.querySelectorAll('.discount-callout');
if (discountCallout && discountCallout.length > 0) {
  discountCallout.forEach((element) => {
    element.addEventListener('click', function() {
      const codeEl = element.querySelector('.discount-callout__code-wrapper');
      const code = codeEl.dataset.copyToClipboard;
      const successMessage = element.querySelector('.discount-callout__code-copied');

      // Copy to clipboard
      navigator.clipboard.writeText(code).then(function() {
        successMessage.style.display = 'block';
        setTimeout(function() {
          successMessage.style.display = 'none';
        }, 3000);
      })
    });
  });
}

*/

document.addEventListener("DOMContentLoaded", () => {
  const reviewsElement = document.querySelector(
    "[data-oke-reviews-product-id]"
  );
  const toReviewsElements = Array.from(
    document.querySelectorAll("[data-scroll-to-reviews]")
  );

  if (!reviewsElement || toReviewsElements.length === 0) return;

  toReviewsElements.forEach((element) => {
    element.addEventListener("click", () => {
      reviewsElement.scrollIntoView({ behavior: "smooth" });
    });
  });
});
